import { useSearch, useSos } from '@front/logic'
import { AppBackground, HeaderWithBack, LocationCard, LocationCardDataProps, Text, ResponsiveLogo } from '@ui/components'
import { FormikValues } from 'formik'
import React, { FC, useEffect, useState } from 'react'
import { useAppSelector } from '@front/store'
import { Container, PinContainer, PlaceholderContainer, ScrollViewContainer } from './style'
import { useNavigate } from 'react-router-dom'
import { TouchableOpacity, View, Image } from 'react-native'
import { HeaderWithBackAena } from '../../../components/headerwithback'
import { t } from 'i18next'

export const SosHistory: FC = () => {
  const navigate = useNavigate()
  const [history, setHistory] = useState<LocationCardDataProps[]>([])
  const { name } = useAppSelector((state) => state.selectedPet)
  const { isLoading } = useAppSelector((state) => state.loading)

  const submite = (_formValues: FormikValues) => {
    console.debug('submite')
  }

  const { values, handleChange, handleBlur } = useSearch({ onNextPress: submite })
  const { getHistory } = useSos({})



  const handleCardPress = (sosGuid: string) => {
    navigate('map', {
      state: {
        sosGuid,
      },
    })
  }

  useEffect(() => {
    const fetchHistory = async () => {
      const { data, success } = await getHistory()
      const h = data?.map((item) => {
        const imageUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${item?.lostLat},${item?.lostLon}&zoom=16&size=500x500&markers=color:red%7Clabel:C%7C${item?.lostLat},${item?.lostLon}&key=AIzaSyCydlBSzE5sbL00JEoEf4BBviSduFu5rdk`
        return {
          name: `${t('common.status')}: ${item?.statusLabel}`,
          imageUrl,
          guid: item?.guid,
          location: {
            name: item?.lostIn,
            latitude: item?.lostLat,
            longitude: item?.lostLon,
          },
        }
      })
      setHistory(h as LocationCardDataProps[])
    }
    fetchHistory()
  }, [])

  return (
    <AppBackground isSafe>
      <Container>
        <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', padding: 16, gap: 16 }}>
            <ResponsiveLogo
                breakpoint={820}
                hysteresis={20}
                large={{ width: 680, height: 96 }}
                small={{ width: 360, height: 48 }}
              />
        </View>
        <HeaderWithBackAena title={'SOS'} />

        {history?.length === 0 ? (
          <>
            {!isLoading && (
              <PlaceholderContainer>
                <Text type="H4" style={{ textAlign: 'center' }}>
                  {`${name} ${t('common.nohistorysos')}`}
                </Text>
              </PlaceholderContainer>
            )}
          </>
        ) : (
          <ScrollViewContainer>
            {history?.map((item, index) => (
              <LocationCard
                data={item}
                onPress={() => handleCardPress(item.guid)}
                key={index}
                pinIcon={<PinContainer>{/* <MapPin width={15} height={15} /> */}</PinContainer>}
              />
            ))}
          </ScrollViewContainer>
        )}
      </Container>
    </AppBackground>
  )
}
